interface SupportEscalationInput {
  actionName: string;
  errorMessage: string;
  errorCode?: string;
  supportRef?: string;
  operationName?: string;
  route?: string;
  extra?: Record<string, string | number | boolean | null | undefined>;
}

const SUPPORT_EMAIL = "support@njoy.live";

const toRecordValue = (value: unknown): string => {
  if (value === null || typeof value === "undefined") {
    return "";
  }

  if (typeof value === "string") {
    return value;
  }

  if (typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }

  return JSON.stringify(value);
};

export const extractSupportMetaFromError = (error: unknown): {
  errorCode?: string;
  supportRef?: string;
  message?: string;
} => {
  const fallback = { errorCode: undefined, supportRef: undefined, message: undefined };

  if (!error || typeof error !== "object") {
    return fallback;
  }

  const maybeApollo = error as {
    graphQLErrors?: Array<{
      message?: string;
      extensions?: {
        code?: string;
        supportRef?: string;
      };
    }>;
    message?: string;
  };

  const firstGraphQLError = maybeApollo.graphQLErrors?.[0];
  const code = firstGraphQLError?.extensions?.code;
  const supportRef = firstGraphQLError?.extensions?.supportRef;

  return {
    errorCode: typeof code === "string" ? code : undefined,
    supportRef: typeof supportRef === "string" ? supportRef : undefined,
    message:
      firstGraphQLError?.message ||
      (typeof maybeApollo.message === "string" ? maybeApollo.message : undefined),
  };
};

export const openSupportEscalationMail = ({
  actionName,
  errorMessage,
  errorCode,
  supportRef,
  operationName,
  route,
  extra,
}: SupportEscalationInput): void => {
  const context = {
    actionName,
    route: route || (typeof window !== "undefined" ? window.location.pathname : ""),
    operationName: operationName || "",
    errorCode: errorCode || "",
    supportRef: supportRef || "",
    timestamp: new Date().toISOString(),
    ...(extra || {}),
  };

  const subjectParts = [actionName, "Issue"];
  if (supportRef) {
    subjectParts.push(`Ref ${supportRef}`);
  }
  const subject = subjectParts.join(" - ");

  const issueContextLabel = operationName || actionName;
  const introLine = issueContextLabel
    ? `I need help with an issue in the app while trying to ${issueContextLabel}.`
    : "I need help with an issue in the app.";
  const issueSummaryLabel = supportRef ? `Issue Summary (Ref: ${supportRef}):` : "Issue Summary:";

  const body = [
    "Hello Support Team,",
    "",
    introLine,
    "",
    issueSummaryLabel,
    errorMessage,
    "",
    "Context:",
    ...Object.entries(context).map(([key, value]) => `${key}: ${toRecordValue(value)}`),
  ].join("\n");

  const href = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  window.location.href = href;
};